<!-- Events -->
<!-- itemCreated -->

<template>
  <v-container fluid>
    <v-row
      dense
    >
<!--      Payment Method Forms-->
      <v-col
        md="4"
        cols="12"
      >
        <base-tile-card>
          <template v-slot:heading>
            <div>
              Make Payment
            </div>
          </template>
          <v-row
            class="mx-auto flex-column elevation-4"
          >
            <v-card
              flat
              class="section-header mx-auto mb-n3"
            >
              Payment Amount
            </v-card>
            <v-card
              v-if="authIsStaff"
              flat
              class="mx-auto section-bullets mt-2 mb-1"
            >
              <v-text-field
                v-model="totalDue"
                type="number"
              ></v-text-field>
            </v-card>
            <v-card
              v-if="!authIsStaff"
              flat
              class="mx-auto section-bullets mt-2 mb-1"
            >
              <p>${{ totalDue }}</p>
            </v-card>
          </v-row>

          <v-radio-group
            v-model="selectedPaymentOption"
          >
            <v-radio
              v-if="false"
              value="void"
              :disabled="!authIsStaff"
            >
              <template
                slot="label"
              >
                <div class="lbl-radio">
                  VOID
                </div>
              </template>
            </v-radio>
            <v-radio
              v-if="authIsStaff"
              value="cash"
              :disabled="!authIsStaff"
            >
              <template
                slot="label"
              >
                <div class="lbl-radio">
                  Cash
                </div>
              </template>
            </v-radio>
            <v-radio
              v-if="authIsStaff"
              value="moneyorder"
              :disabled="!authIsStaff"
            >
              <template
                slot="label"
              >
                <div class="lbl-radio">
                  Money Order
                </div>
              </template>
            </v-radio>
            <v-radio
              v-if="authIsStaff"
              value="check"
              :disabled="!authIsStaff"
            >
              <template
                slot="label"
              >
                <div class="lbl-radio">
                  Check
                </div>
              </template>
            </v-radio>
            <v-radio
              v-if="isSavedCardValid"
              value="savedCC"
              :disabled="!isSavedCardValid"
            >
              <template
                slot="label"
              >
                <div class="lbl-radio">
                  Saved Credit Card
                </div>
              </template>
            </v-radio>
            <v-radio
              v-if="isSavedEcheckValid"
              :disabled="!isSavedEcheckValid"
              value="savedECheck"
            >
              <template
                slot="label"
              >
                <div class="lbl-radio">
                  Saved E-Check
                </div>
              </template>
            </v-radio>
            <v-radio
              value="newCC"
            >
              <template
                slot="label"
                class="lbl-radio"
              >
                <span class="lbl-radio">New Credit Card</span>
              </template>
            </v-radio>
            <v-radio
              value="newECheck"
            >
              <template
                slot="label"
              >
                <span class="lbl-radio">New E-Check</span>
              </template>
            </v-radio>
          </v-radio-group>
          <!--                cash-->
          <v-card
            v-if="selectedPaymentOption === 'cash'"
            class="mx-0 pa-4"
          >
            <div class="section-subheader">
              Cash
            </div>
            <v-row>
              <v-col
                cols="4"
                class="d-flex flex-column my-auto"
              >
                Cash Tendered:
              </v-col>
              <v-col
                cols="8"
                class="d-flex flex-column my-auto"
              >
                <v-text-field
                  v-model="cashInfo.tendered"
                  type="number"
                >
                </v-text-field>
              </v-col>

            </v-row>
            <v-row>
              <v-col
                cols="4"
                class="d-flex flex-column my-auto"
              >
                Change Due:
              </v-col>
              <v-col
                cols="8"
                class="d-flex flex-column my-auto"
              >
                <v-text-field
                  v-model="cashInfo.change"
                  readonly
                  filled
                >
                </v-text-field>
              </v-col>
              <v-alert
                v-if="cashInfo.errors.length > 0"
                type="error"
              >
                <ul>
                  <li
                    v-for="(err, i) in cashInfo.errors"
                    :key="i"
                  >
                    {{ err }}
                  </li>
                </ul>
              </v-alert>
            </v-row>
          </v-card>
          <!--                money order-->
          <v-card
            v-if="selectedPaymentOption === 'moneyorder'"
            class="mx-0 pa-4"
          >
            <div class="section-subheader">
              Money Order
            </div>
            <v-row>
              <v-col
                cols="4"
                class="d-flex flex-column my-auto"
              >
                Check Number:
              </v-col>
              <v-col
                cols="8"
                class="d-flex flex-column my-auto"
              >
                <v-text-field
                  v-model="moneyorderInfo.refNumber"
                >
                </v-text-field>
              </v-col>

            </v-row>
            <v-alert
              v-if="moneyorderInfo.errors.length > 0"
              type="error"
            >
              <ul>
                <li
                  v-for="(err, i) in moneyorderInfo.errors"
                  :key="i"
                >
                  {{ err }}
                </li>
              </ul>
            </v-alert>
          </v-card>
          <!--                check-->
          <v-card
            v-if="selectedPaymentOption === 'check'"
            class="mx-0 pa-4"
          >
            <div class="section-subheader">
              Check
            </div>
            <v-row>
              <v-col
                cols="4"
                class="d-flex flex-column my-auto"
              >
                Name:
              </v-col>
              <v-col
                cols="8"
                class="d-flex flex-column my-auto"
              >
                <v-text-field
                  v-model="checkInfo.name"
                >
                </v-text-field>
              </v-col>
              <v-col
                cols="4"
                class="d-flex flex-column my-auto"
              >
                Check Number:
              </v-col>
              <v-col
                cols="8"
                class="d-flex flex-column my-auto"
              >
                <v-text-field
                  v-model="checkInfo.refNumber"
                >
                </v-text-field>
              </v-col>
              <v-alert
                v-if="checkInfo.errors.length > 0"
                type="error"
              >
                <ul>
                  <li
                    v-for="(err, i) in checkInfo.errors"
                    :key="i"
                  >
                    {{ err }}
                  </li>
                </ul>
              </v-alert>

            </v-row>
          </v-card>
          <!--                saved credit card-->
          <v-card
            v-if="selectedPaymentOption === 'savedCC'"
            class="mx-0 pa-4"
          >
            <div class="section-subheader">
              Saved Credit Card
            </div>
            <v-row>
              <v-col
                cols="12"
              >
                <v-radio-group
                  v-model="selectedAccount._ccInfo.cctype"
                  disabled
                >
                  <v-radio
                    value="VISA"
                  >
                    <template v-slot:label>
                      <div class="lbl-radio">VISA</div>
                    </template>
                  </v-radio>
                  <v-radio
                    value="MASTERCARD"
                  >
                    <template v-slot:label>
                      <div class="lbl-radio">MASTERCARD</div>
                    </template>
                  </v-radio>
                </v-radio-group>
              </v-col>
              <v-col
                cols="12"
                class="d-flex flex-column"
              >
                <v-text-field
                  id="ccattn"
                  v-model="acctSelectedAccount._ccInfo.acctnumber"
                  disabled
                >
                  <template v-slot:label>
                    Card Number
                  </template>
                </v-text-field>
                <v-select
                  v-model="acctSelectedAccount._ccInfo.ccMonth"
                  :items="optsMonths"
                  disabled
                  label="Expiration Month"
                ></v-select>
                <v-select
                  v-model="acctSelectedAccount._ccInfo.ccYear"
                  :items="optsYears"
                  disabled
                  label="Expiration Year"
                ></v-select>
              </v-col>
              <v-col
                cols="12"
              >
                <v-text-field
                  id="ccattn"
                  v-model="acctSelectedAccount._ccInfo.attn"
                  disabled
                >
                  <template v-slot:label>
                    Name on Card
                  </template>
                </v-text-field>
              </v-col>
              <v-col
                cols="12"
              >
                <v-text-field
                  v-model="acctSelectedAccount._ccInfo.addr1"
                  disabled
                >
                  <template v-slot:label>
                    Address 1
                  </template>
                </v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-text-field
                  v-model="acctSelectedAccount._ccInfo.city"
                  disabled
                >
                  <template v-slot:label>
                    City
                  </template>
                </v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-text-field
                  v-model="acctSelectedAccount._ccInfo.state"
                  disabled
                >
                  <template v-slot:label>
                    State
                  </template>
                </v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-text-field
                  v-model="acctSelectedAccount._ccInfo.zip"
                  disabled
                >
                  <template v-slot:label>
                    Zip Code
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-card>
          <!--                saved echeck-->
          <v-card
            v-if="selectedPaymentOption === 'savedECheck'"
            class="mx-0 pa-4"
          >
            <div class="section-subheader">
              Saved Echeck
            </div>
            <v-row>
              <v-form
                ref="formEcheck"
              >
                <v-radio-group
                  v-model="selectedAccount._echeckInfo.bank_acct_type"
                  disabled
                >
                  <v-radio
                    value="1"
                  >
                    <template v-slot:label>
                      <div class="lbl-radio">Checking</div>
                    </template>
                  </v-radio>
                  <v-radio
                    value="2"
                  >
                    <template v-slot:label>
                      <div class="lbl-radio">Savings</div>
                    </template>
                  </v-radio>
                </v-radio-group>
                <v-row>
                  <v-col
                    cols="12"
                  >
                    <v-text-field
                      v-model="selectedAccount._echeckInfo.routenumber"
                      label="Route Number"
                      disabled
                    >
                      <template v-slot:label>
                        Route Number
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                  >
                    <v-text-field
                      v-model="selectedAccount._echeckInfo.acctnumber"
                      label="Account Number"
                      disabled
                    >
                      <template v-slot:label>
                        Account Number
                      </template>
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                  >
                    <v-text-field
                      v-model="acctSelectedAccount._echeckInfo.attn"
                      label="Name on Account"
                      disabled
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                  >
                    <v-text-field
                      v-model="acctSelectedAccount._echeckInfo.addr1"
                      disabled
                    >
                      <template v-slot:label>
                        Address 1
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model="acctSelectedAccount._echeckInfo.city"
                      disabled
                    >
                      <template v-slot:label>
                        City
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model="acctSelectedAccount._echeckInfo.state"
                      disabled
                    >
                      <template v-slot:label>
                        State
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model="acctSelectedAccount._echeckInfo.zip"
                      disabled
                    >
                      <template v-slot:label>
                        Zip Code
                      </template>
                    </v-text-field>
                  </v-col>
                </v-row>

              </v-form>
            </v-row>
          </v-card>
          <!--                new echeck/ach -->
          <v-card
            v-if="selectedPaymentOption === 'newECheck'"
            class="mx-0 pa-4"
          >
            <div class="section-subheader">
              New Echeck
            </div>
            <v-row>
              <v-form
                ref="newFormEcheck"
              >
                <v-radio-group
                  v-model="newEcheckInfo.bank_acct_type"
                  :rules="[rules.required]"
                >
                  <v-radio
                    value="1"
                  >
                    <template v-slot:label>
                      <div class="lbl-radio">Checking</div>
                    </template>
                  </v-radio>
                  <v-radio
                    value="2"
                  >
                    <template v-slot:label>
                      <div class="lbl-radio">Savings</div>
                    </template>
                  </v-radio>
                </v-radio-group>
                <v-row>
                  <v-col
                    cols="12"
                  >
                    <v-text-field
                      v-model="newEcheckInfo.routenumber"
                      label="Route Number"
                      :rules="[rules.required]"
                    >
                      <template v-slot:label>
                        Route Number
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                  >
                    <v-text-field
                      v-model="newEcheckInfo.acctnumber"
                      label="Account Number"
                      :rules="[rules.required]"
                    >
                      <template v-slot:label>
                        Account Number
                      </template>
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                  >
                    <v-text-field
                      v-model="newEcheckInfo.attn"
                      label="Name on Account"
                      :rules="[rules.required]"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                  >
                    <v-text-field
                      v-model="newEcheckInfo.addr1"
                      :rules="[rules.required]"
                    >
                      <template v-slot:label>
                        Address 1
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model="newEcheckInfo.city"
                      :rules="[rules.required]"
                    >
                      <template v-slot:label>
                        City
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model="newEcheckInfo.state"
                      :rules="[rules.required]"
                    >
                      <template v-slot:label>
                        State
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model="newEcheckInfo.zip"
                      :rules="[rules.required]"
                    >
                      <template v-slot:label>
                        Zip Code
                      </template>
                    </v-text-field>
                  </v-col>
                </v-row>

              </v-form>
            </v-row>
          </v-card>
          <!--                new credit card-->
          <v-card
            v-if="selectedPaymentOption === 'newCC'"
            class="mx-0 pa-4"
          >
            <div class="section-subheader">
              New Credit Card
            </div>
            <v-form
              ref="newCCPayment"
            >
              <v-row>
                <v-col
                  cols="12"
                >
                  <v-radio-group
                    v-model="newCCInfo.cctype"
                    :rules="[rules.required]"
                  >
                    <v-radio
                      value="VISA"
                    >
                      <template v-slot:label>
                        <div class="lbl-radio">VISA</div>
                      </template>
                    </v-radio>
                    <v-radio
                      value="MASTERCARD"
                    >
                      <template v-slot:label>
                        <div class="lbl-radio">MASTERCARD</div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </v-col>
                <v-col
                  cols="12"
                  class="d-flex flex-column"
                >
                  <v-text-field
                    id="ccattn"
                    v-model="newCCInfo.acctnumber"
                    :rules="[rules.required]"
                  >
                    <template v-slot:label>
                      Card Number
                    </template>
                  </v-text-field>
                  <v-select
                    v-model="newCCInfo.ccMonth"
                    :items="optsMonths"
                    :rules="[rules.required]"
                    label="Expiration Month"
                  ></v-select>
                  <v-select
                    v-model="newCCInfo.ccYear"
                    :items="optsYears"
                    :rules="[rules.required]"
                    label="Expiration Year"
                  ></v-select>
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    id="ccattn"
                    v-model="newCCInfo.attn"
                    :rules="[rules.required]"
                  >
                    <template v-slot:label>
                      Name on Card
                    </template>
                  </v-text-field>
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="newCCInfo.addr1"
                    :rules="[rules.required]"
                  >
                    <template v-slot:label>
                      Address 1
                    </template>
                  </v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-model="newCCInfo.city"
                    :rules="[rules.required]"
                  >
                    <template v-slot:label>
                      City
                    </template>
                  </v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-model="newCCInfo.state"
                    :rules="[rules.required]"
                  >
                    <template v-slot:label>
                      State
                    </template>
                  </v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-model="newCCInfo.zip"
                    :rules="[rules.required]"
                  >
                    <template v-slot:label>
                      Zip Code
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-card>
          <v-card
            flat
            class="px-3 pb-3 mx-3 card-full-width"
          >
            <v-alert
              v-if="acctPostPaymentErrors.length > 0"
              type="error"
            >
              <ul>
                <li
                  v-for="(err, i) in acctPostPaymentErrors"
                  :key="i"
                >
                  {{ err }}
                </li>
              </ul>
            </v-alert>
          </v-card>
          <v-card
            v-if="confirmPaymentDialog"
            flat
          >
            <v-btn
              tile
              color="primary"
              class="mr-3"
              :loading="acctIsPostingPayment"
              :disabled="!canMakePayment"
              @click="doProcessPayment"
            >
              Confirm Payment
            </v-btn>
            <v-btn
              tile
              color="secondary"
              @click="confirmPaymentDialog = false"
            >
              Cancel
            </v-btn>
          </v-card>
          <v-card
            v-else
            flat
          >
            <v-btn
              tile
              color="primary"
              @click="confirmPaymentDialog = true"
            >
              Make Payment
            </v-btn>
          </v-card>
        </base-tile-card>
      </v-col>
<!--      Unpaid Invoices-->
      <v-col
        md="8"
        cols="12"
      >
        <base-tile-card>
          <template v-slot:heading>
            <div>
              Unpaid Invoices
            </div>
          </template>
          <v-data-table
            v-model="selectedInvoices"
            :items="unpaidInvoices"
            :headers="headersUrgentInvoices"
            :loading="acctIsGettingAccountInvoices"
            item-key="invoice"
            show-expand
            fixed-header
            height="600"
            disable-pagination
            :single-expand="true"
          >
            <template v-slot:no-data>
              <h1>No Unpaid invoices! You are current.</h1>
            </template>
            <template v-slot:item._selected="{ item }">
              <v-container
                v-if="authIsStaff"
              >
                <v-checkbox
                  :value="item.selected"
                  v-ripple
                  @click.stop="onInvoiceSelected(item)"
                ></v-checkbox>
              </v-container>
              <v-container
                v-else
              >
                <v-checkbox
                  v-if="item.selected"
                  :value="true"
                  v-ripple
                  :readonly="item.status === 'OVERDUE'"
                  :disabled="item.status === 'OVERDUE'"
                  @click.stop="onInvoiceSelected(item)"
                ></v-checkbox>
                <v-checkbox
                  v-if="!item.selected"
                  :value="false"
                  v-ripple
                  :readonly="item.status === 'OVERDUE'"
                  :disabled="item.status === 'OVERDUE'"
                  @click.stop="onInvoiceSelected(item)"
                ></v-checkbox>
              </v-container>
            </template>
            <template v-slot:item.due="{ item }">
              ${{ item.due.toFixed(2) }}
            </template>
            <template v-slot:item.status="{ item }">
              {{ item.status }}
            </template>
            <template v-slot:item._action="{ item }">
              <v-btn
                @click="doStartInvDownload(item)"
              >
                Download
              </v-btn>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
              <td
                class="py-2"
                style="background-color: lightblue"
                :colspan="headers.length"
              >
                <h3>
                  Invoice Details for {{ item.invoice }}
                </h3>
                <pow-invoice-details
                  :item="item"
                ></pow-invoice-details>
              </td>
            </template>
          </v-data-table>
        </base-tile-card>
      </v-col>
    </v-row>
<!--    Payment Success Dialog-->
    <v-row>
      <v-col cols="auto">
        <v-dialog
          v-model="paymentSuccessDialog"
          transition="dialog-bottom-transition"
          persistent
          max-width="600"
        >
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >Payment Successfully Applied</v-toolbar>
            <v-card-text>
              <div class="section-header">Payment has successfully been applied to your account!</div>
              <v-row>
                <v-btn
                  :href="paymentUrl"
                  target="_blank"
                  class="mx-auto mt-5 blue darken-2"
                  large
                  tile
                >
                  <v-icon
                    large
                  >
                    mdi-receipt
                  </v-icon>
                  Preview Receipt
                </v-btn>
              </v-row>
              <v-container>
              </v-container>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn
                text
                @click="paymentSuccessDialog = false"
              >Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
  // Utilities
  import {
    mapActions, mapGetters, mapMutations,
  } from 'vuex'
  import {
    _COMMIT_LOG,
    _DOWNLOAD_INVOICE,
    ACCT_GET_ACCOUNT,
    ACCT_GET_ACCOUNT_INVOICES,
    ACCT_POST_PAYMENT_CC,
    ACCT_POST_PAYMENT_ECHECK, ACCT_POST_PAYMENT_CASH, ACCT_POST_PAYMENT_CHECK, ACCT_POST_PAYMENT_MONEYORDER,
    ACCT_POST_PAYMENT_VOID,
    ACCT_UPDATE_CREDIT_CARD,
    ACCT_UPDATE_ECHECK,
    ACCT_UPDATE_STMT_METH,
  } from '../../store/actions.types'
  import basicMixin from '../../mixins/basic'
  import moment from '../../assets/js/moment.min'
  import {
    ACCT_SET_ERRORS_CC_FORM, ACCT_SET_ERRORS_ECHECK_FORM,
    ACCT_SET_ERRORS_POST_PAYMENT,
    ACCT_UPDATE_SELECTED_ACCOUNT_UNPAID_INV,
  } from '../../store/mutations.types'
  export default {
    name: 'AccountPayment',
    components: {
      PowInvoiceDetails: () => import('@/components/pow/InvoiceDetails'),
    },
    mixins: [basicMixin],

    inheritAttrs: false,

    props: {
      item: {
        type: Object,
        default: () => ({
          name: undefined,
          invoice: undefined,
          due_date: undefined,
          total: undefined,
          paid: undefined,
          is_paid: undefined,
          details: undefined,
        }),
      },
    },
    data: function () {
      return {
        confirmPaymentDialog: false,
        paymentSuccessDialog: false,
        selectedInvoices: [],
        paidInvoices: [],
        updateStatementErrors: [],
        urgentInvoices: [],
        totalDue: 0,
        paymentId: null,
        headersUrgentInvoices: [
          {
            text: '',
            align: 'start',
            sortable: true,
            groupable: false,
            value: '_selected',
          },
          {
            text: 'Invoice',
            align: 'start',
            sortable: true,
            groupable: false,
            value: 'invoice',
          },
          {
            text: 'Due Date',
            align: 'start',
            sortable: true,
            groupable: false,
            value: 'due_formatted',
          },
          {
            text: 'Amt Due',
            align: 'start',
            sortable: true,
            groupable: false,
            value: 'due',
          },
          {
            text: 'Status',
            align: 'start',
            sortable: false,
            groupable: false,
            value: 'status',
          },
          {
            text: 'Action',
            align: 'start',
            sortable: false,
            groupable: false,
            value: '_action',
          },
        ],
        selectedPaymentOption: '',
        statementMethodChanged: false,
        cashInfo: {
          tendered: 0,
          change: 0,
          errors: [],
        },
        checkInfo: {
          refNumber: '',
          name: '',
          errors: [],
        },
        moneyorderInfo: {
          refNumber: '',
          errors: [],
        },
        newEcheckInfo: {
          attn: '',
          bank_acct_type: '',
          routenumber: '',
          banknumbermasked: '',
          acctnumber: '',
        },
        newCCInfo: {
          attn: '',
          cctype: '',
          creditcardmasked: '',
          acctnumber: '',
          ccMonth: null,
          ccYear: null,
        },
        isPageLoading: false,
        rules: {
          required: value => !!value || 'Required.',
          min: v => v.length >= 8 || 'Min 8 characters',
          mustAccept: v => v >= 1 || 'Must accept to continue',
          counter: value => value.length <= 20 || 'Max 20 characters',
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          },
        },
      }
    },
    watch: {
      'urgentInvoices.selected' (val) {
        console.log('Urgent Invoices', val)
        this.markUnpaidInvoice()
      },
      acctSelectedAccount: {
        handler: function (val, oldVal) {
          this.doGetUnpaidInvoices()
        },
        deep: true,
      },
      unpaidInvoices: {
        handler: function (val, oldVal) {
          this.updateSelectedAccountUnpaidInvoices(val)
        },
        deep: true,
      },
      'cashInfo.tendered': {
        handler: function (val, oldVal) {
          if (this.cashInfo.tendered > this.totalDue) {
            this.cashInfo.change = (this.cashInfo.tendered - this.totalDue).toFixed(2)
          } else {
            this.cashInfo.change = 0
          }
        },
        deep: true,
      },
      totalDue: {
        handler: function (val, oldVal) {
          if (this.cashInfo.tendered > this.totalDue) {
            this.cashInfo.change = (this.cashInfo.tendered - this.totalDue).toFixed(2)
          } else {
            this.cashInfo.change = 0
          }
        },
        deep: true,
      },
    },

    computed: {
      ...mapGetters([
        'acctCCErrors', 'acctAccounts', 'acctSelectedAccount',
        'optsMonths', 'optsYears', 'acctIsUpdatingPaymentDetails', 'acctIsGettingAccountInvoices',
        'acctEcheckErrors', 'acctPostPaymentErrors', 'acctIsPostingPayment', 'authIsStaff',
      ]),
      ...mapGetters({
        selectedAccount: 'acctSelectedAccount',
        unpaidInvoices: 'acctSelectedAccountUnpaidInvoices',
      }),
      isSavedCardValid: function () {
        let validMonth = false
        let validYear = false
        let ccLengthValid = false
        if (!this.acctSelectedAccount._ccInfo) {
          return false
        }
        if (this.acctSelectedAccount._ccInfo &&
          this.acctSelectedAccount._ccInfo.acctnumber) {
          ccLengthValid = this.acctSelectedAccount._ccInfo.acctnumber.length > 0
        }
        const now = moment()

        if (this.acctSelectedAccount._ccInfo.ccYear && this.acctSelectedAccount._ccInfo.ccYear >= now.year()) {
          validYear = true
          if (this.acctSelectedAccount._ccInfo.ccYear === now.year() && this.acctSelectedAccount._ccInfo.ccMonth >= now.month() + 1) {
            validMonth = true
          } else if (this.acctSelectedAccount._ccInfo.ccYear > now.year() && this.acctSelectedAccount._ccInfo.ccMonth > 0) {
            validMonth = true
          }
        }
        if (ccLengthValid && validYear && validMonth && validYear) {
          return true
        }
        console.log(`CClength: ${ccLengthValid}, validYear: ${validYear}, validMonth: ${validMonth}`)
        return false
      },
      isSavedEcheckValid: function () {
        if (!this.selectedAccount._echeckInfo || !this.selectedAccount._echeckInfo.routenumber) {
          return false
        }
        const routenumberLengthValid = this.selectedAccount._echeckInfo.routenumber.length > 0
        const acctnumberLengthValid = this.selectedAccount._echeckInfo.acctnumber.length > 0
        if (routenumberLengthValid && acctnumberLengthValid) {
          return true
        }
        return false
      },
      canMakePayment: function () {
        if (this.authIsStaff) {
          return (this.selectedPaymentOption !== '' && this.totalDue >= 0)
        }
        return (this.selectedPaymentOption !== '' && this.unpaidInvoices.length > 0 && this.totalDue > 0)
      },
      paymentUrl: function () {
        return `/#/public-reporting/payment-receipt?account=${this.selectedAccount.rowkey}&payment=${this.paymentId}`
      },
    },
    async created () {
      // this.init()
      await this.doGetUnpaidInvoices()
    },
    async mounted () {
      this.init()
      await this.doGetUnpaidInvoices()
    },
    methods: {
      init () {
        this.formMode = 'read'
        // init check info - set name
        this.checkInfo.name = this.acctSelectedAccount._addresses.service.attn
        // init credit card to credit card address
        this.newCCInfo.attn = this.acctSelectedAccount._addresses.creditCard.attn
        this.newCCInfo.addr1 = this.acctSelectedAccount._addresses.creditCard.addr1
        this.newCCInfo.city = this.acctSelectedAccount._addresses.creditCard.city
        this.newCCInfo.state = this.acctSelectedAccount._addresses.creditCard.state
        this.newCCInfo.zip = this.acctSelectedAccount._addresses.creditCard.zip
        // init echeck to echeck address
        this.newEcheckInfo.attn = this.acctSelectedAccount._addresses.echeck.attn
        this.newEcheckInfo.addr1 = this.acctSelectedAccount._addresses.echeck.addr1
        this.newEcheckInfo.city = this.acctSelectedAccount._addresses.echeck.city
        this.newEcheckInfo.state = this.acctSelectedAccount._addresses.echeck.state
        this.newEcheckInfo.zip = this.acctSelectedAccount._addresses.echeck.zip
      },
      ...mapActions(['getAccount', 'getUnpaidInvoices', 'getECheckInfo',
                     'getCreditCardInfo']),
      ...mapActions({
        commitLog: _COMMIT_LOG,
        getAccount: ACCT_GET_ACCOUNT,
        getAccountInvoices: ACCT_GET_ACCOUNT_INVOICES,
        updateStatementMethod: ACCT_UPDATE_STMT_METH,
        updateCreditCard: ACCT_UPDATE_CREDIT_CARD,
        updateEcheck: ACCT_UPDATE_ECHECK,
        postPaymentCC: ACCT_POST_PAYMENT_CC,
        postPaymentEcheck: ACCT_POST_PAYMENT_ECHECK,
        postPaymentCash: ACCT_POST_PAYMENT_CASH,
        postPaymentCheck: ACCT_POST_PAYMENT_CHECK,
        postPaymentMoneyorder: ACCT_POST_PAYMENT_MONEYORDER,
        postPaymentVoid: ACCT_POST_PAYMENT_VOID,
        downloadInvoice: _DOWNLOAD_INVOICE,
      }),
      ...mapMutations({
        updateSelectedAccountUnpaidInvoices: ACCT_UPDATE_SELECTED_ACCOUNT_UNPAID_INV,
        setPostPaymentErrors: ACCT_SET_ERRORS_POST_PAYMENT,
        setCCFormErrors: ACCT_SET_ERRORS_CC_FORM,
        setEcheckFormErrors: ACCT_SET_ERRORS_ECHECK_FORM,
      }),
      async doStartInvDownload (invoice) {
        let invoiceId = null
        if (typeof invoice === 'string' || this.isInt(invoice)) {
          invoiceId = invoice
        } else if (invoice && invoice.invoice) {
          invoiceId = invoice.invoice
        }
        if (!invoiceId) {
          alert('Error downloading invoice')
        }
        this.isPageLoading = true
        this.commitLog({ message: `Starting invoice download for invoice: ${invoiceId}`, invoiceId })
        const invPayload = {
          account_key: this.selectedAccount.rowkey,
          invoice_key: invoiceId,
          filename: `invoice_${invoiceId}`,
        }
        this.commitLog({ message: `Starting invoice download payload: ${invoiceId}`, invPayload })
        await this.downloadInvoice(invPayload)
        this.isPageLoading = false
      },
      async doGetECheckInfo () {
        try {
          const eCheckInfo = await this.getECheckInfo({ custid: this.selectedAccount.id })
          console.log(eCheckInfo)
        } catch (e) {
          console.log(e)
        }
      },
      async doGetCCInfo () {
        try {
          this.ccInfo = await this.getCreditCardInfo({ custid: this.selectedAccount.id })
          console.log('CreditCard Info:', this.ccInfo)
        } catch (e) {
          console.log(e)
        }
      },
      async doGetUnpaidInvoices () {
        await this.getAccountInvoices({ rowkey: this.selectedAccount.rowkey, unpaid: true })
        this.markUnpaidInvoice()
      },
      async doProcessPayment () {
        console.log('Preparring to processess payment for selected invoices')
        const paymentPaylod = {}
        paymentPaylod.rowkey = this.acctSelectedAccount.rowkey
        const total = this.totalDue
        const invoices = []
        if (this.unpaidInvoices && this.unpaidInvoices.length > 0) {
          for (const invoice of this.unpaidInvoices) {
            if (invoice.selected) {
              invoices.push(invoice.invoice)
              // total += invoice.due
            }
          }
        }
        console.log('selected invoices for payment:', invoices)
        console.log('selected total for payment:', total)
        paymentPaylod.tender = total
        paymentPaylod.invoices = invoices
        let validForm = false
        switch (this.selectedPaymentOption) {
          case '':
            console.log('payment option must be selected')
            break
          case 'newCC':
            validForm = this.$refs.newCCPayment.validate()
            console.log('New CC option selected')
            paymentPaylod.attn = this.newCCInfo.attn
            paymentPaylod.type = this.newCCInfo.cctype
            paymentPaylod.number = this.newCCInfo.acctnumber
            paymentPaylod.month = this.newCCInfo.ccMonth
            paymentPaylod.year = this.newCCInfo.ccYear
            paymentPaylod.addr1 = this.newCCInfo.addr1
            paymentPaylod.city = this.newCCInfo.city
            paymentPaylod.state = this.newCCInfo.state
            paymentPaylod.zip = this.newCCInfo.zip
            break
          case 'newECheck':
            validForm = this.$refs.newFormEcheck.validate()
            console.log('New Echeck option selected')
            paymentPaylod.attn = this.newEcheckInfo.attn
            paymentPaylod.type = this.newEcheckInfo.bank_acct_type
            paymentPaylod.acct_number = this.newEcheckInfo.acctnumber
            paymentPaylod.route_number = this.newEcheckInfo.routenumber
            paymentPaylod.addr1 = this.newEcheckInfo.addr1
            paymentPaylod.city = this.newEcheckInfo.city
            paymentPaylod.state = this.newEcheckInfo.state
            paymentPaylod.zip = this.newEcheckInfo.zip
            break
          case 'savedCC':
            // todo recheck saved credit card is valid
            // hardcoded to true for now as it is pre-checked before displaying option
            validForm = true // await this.verifyCreditCardForm()
            console.log('Saved CC option selected')
            paymentPaylod.attn = this.selectedAccount._ccInfo.attn
            paymentPaylod.type = this.selectedAccount._ccInfo.cctype
            paymentPaylod.number = this.selectedAccount._ccInfo.acctnumber
            paymentPaylod.month = this.selectedAccount._ccInfo.ccMonth
            paymentPaylod.year = this.selectedAccount._ccInfo.ccYear
            paymentPaylod.addr1 = this.selectedAccount._ccInfo.addr1
            paymentPaylod.city = this.selectedAccount._ccInfo.city
            paymentPaylod.state = this.selectedAccount._ccInfo.state
            paymentPaylod.zip = this.selectedAccount._ccInfo.zip
            break
          case 'savedECheck':
            validForm = await this.verifyEcheckForm()
            console.log('Saved Echeck option selected')
            paymentPaylod.attn = this.selectedAccount._echeckInfo.attn
            paymentPaylod.type = this.selectedAccount._echeckInfo.bank_acct_type
            paymentPaylod.acct_number = this.selectedAccount._echeckInfo.acctnumber
            paymentPaylod.route_number = this.selectedAccount._echeckInfo.routenumber
            paymentPaylod.addr1 = this.selectedAccount._echeckInfo.addr1
            paymentPaylod.city = this.selectedAccount._echeckInfo.city
            paymentPaylod.state = this.selectedAccount._echeckInfo.state
            paymentPaylod.zip = this.selectedAccount._echeckInfo.zip
            break
          case 'cash':
            validForm = await this.verifyCashForm()
            console.log('Cash option selected')
            break
          case 'check':
            validForm = await this.verifyCheckForm()
            paymentPaylod.name = this.checkInfo.name
            paymentPaylod.check_number = this.checkInfo.refNumber
            console.log('Check option selected')
            break
          case 'moneyorder':
            validForm = await this.verifyMoneyorderForm()
            paymentPaylod.check_number = this.moneyorderInfo.refNumber
            console.log('Moneyorder option selected')
            break
          case 'void':
            validForm = true
            console.log('VOID option selected')
            break
        }
        this.commitLog({ message: `Form ${this.selectedPaymentOption} vaild: ${validForm}`, paymentPaylod })
        if (!validForm) {
          this.setPostPaymentErrors(['Please check required fields.'])
          console.log('Form is not valid, exiting payment')
          return
        }
        let paymentResponse = null
        if (this.selectedPaymentOption === 'newCC' || this.selectedPaymentOption === 'savedCC') {
          paymentResponse = await this.postPaymentCC(paymentPaylod)
        } else if (this.selectedPaymentOption === 'newECheck' || this.selectedPaymentOption === 'savedECheck') {
          paymentResponse = await this.postPaymentEcheck(paymentPaylod)
          // paymentResponse = true
        } else if (this.selectedPaymentOption === 'cash') {
          paymentResponse = await this.postPaymentCash(paymentPaylod)
        } else if (this.selectedPaymentOption === 'check') {
          paymentResponse = await this.postPaymentCheck(paymentPaylod)
        } else if (this.selectedPaymentOption === 'moneyorder') {
          paymentResponse = await this.postPaymentMoneyorder(paymentPaylod)
        } else if (this.selectedPaymentOption === 'void') {
          paymentResponse = await this.postPaymentMoneyorder(paymentPaylod)
        }
        if (paymentResponse) {
          if (paymentResponse.response && paymentResponse.response.paymentId) {
            this.paymentId = paymentResponse.response.paymentId
          }
          this.paidInvoices = [...invoices]
          this.paymentSuccessDialog = true
          this.confirmPaymentDialog = false
          await this.doGetUnpaidInvoices()
          // await this.doGetUnpaidInvoices()
        }
        console.log(paymentResponse)
      },
      async verifyCreditCardForm () {
        this.commitLog({ message: 'Verifying Credit Card form...', form: this })
        // const payload = {
        //   rowkey: this.acctSelectedAccount.rowkey,
        //   attn: this.acctSelectedAccount._ccInfo.attn,
        //   type: this.acctSelectedAccount._ccInfo.cctype,
        //   number: this.acctSelectedAccount._ccInfo.acctnumber,
        //   month: this.acctSelectedAccount._ccInfo.ccMonth,
        //   year: this.acctSelectedAccount._ccInfo.ccYear,
        //   addr1: this.acctSelectedAccount._ccInfo.addr1,
        //   city: this.acctSelectedAccount._ccInfo.city,
        //   state: this.acctSelectedAccount._ccInfo.state,
        //   zip: this.acctSelectedAccount._ccInfo.zip,
        // }
        const formIsValid = this.$refs.formCreditCard.validate()
        if (!formIsValid) {
          this.setCCFormErrors(['Please make sure all fields are filled and try again.'])
          return false
        }
        this.setCCFormErrors([])
        this.commitLog({ message: 'Credit card form is valid: ', formIsValid })
        return formIsValid
      },
      async verifyEcheckForm () {
        const formIsValid = this.$refs.formEcheck.validate()
        if (!formIsValid) {
          this.setEcheckFormErrors(['Please make sure all fields are filled and try again.'])
          return false
        }
        this.setEcheckFormErrors([])
        this.commitLog({ message: 'Echeck form is valid: ', formIsValid })
        return formIsValid
      },
      async verifyCashForm () {
        this.cashInfo.errors = []
        let formIsValid = true
        if (this.cashInfo.tendered < 0) {
          formIsValid = false
          this.cashInfo.errors.push('Please make sure to fill the cash tendered from customer.')
        }
        if (!formIsValid) {
          return false
        }
        this.commitLog({ message: 'Cash form is valid: ', formIsValid })
        return formIsValid
      },
      async verifyCheckForm () {
        let formIsValid = true
        this.checkInfo.errors = []
        if (this.checkInfo.refNumber === '') {
          this.checkInfo.errors.push('Please make sure to enter the check number.')
          formIsValid = false
        }
        if (!formIsValid) {
          return false
        }
        this.commitLog({ message: 'Check form is valid: ', formIsValid })
        return formIsValid
      },
      async verifyMoneyorderForm () {
        let formIsValid = true
        this.moneyorderInfo.errors = []
        if (this.moneyorderInfo.refNumber === '') {
          this.moneyorderInfo.errors.push('Please make sure to enter the check number.')
          formIsValid = false
        }
        if (!formIsValid) {
          return false
        }
        this.commitLog({ message: 'Moneyorder form is valid: ', formIsValid })
        return formIsValid
      },
      markUnpaidInvoice () {
        if (this.unpaidInvoices && this.unpaidInvoices.length > 0) {
          for (const invoice of this.unpaidInvoices) {
            if (invoice.status === 'OVERDUE') {
              this.selectedInvoices.push(invoice.invoice)
              invoice.selected = true
            }
          }
        }
        this.updateTotalDue()
      },
      onInvoiceSelected (invoice) {
        this.commitLog({ message: 'Invoice selected changed; oldvalue:', invoice })
        if (invoice.status === 'OVERDUE' && !this.authIsStaff) return
        const entryIndex = this.unpaidInvoices.findIndex(c => c.invoice === invoice.invoice)
        invoice.selected = !invoice.selected
        this.unpaidInvoices[entryIndex] = invoice
        this.updateSelectedAccountUnpaidInvoices(this.unpaidInvoices)
        this.updateTotalDue()
      },
      async onStatementMethodChange (event) {
        this.statementMethodChanged = true
        console.log(event)
      },
      updateTotalDue () {
        this.commitLog({ message: 'Updating total due...' })
        let total = 0
        if (this.unpaidInvoices && this.unpaidInvoices.length > 0) {
          for (const invoice of this.unpaidInvoices) {
            if (invoice.selected) {
              total += invoice.due
            }
          }
        }
        total = total.toFixed(2)
        this.totalDue = total
        return total
      },
    },

  }
</script>

<style>
</style>
